import React from 'react';
import { useNavigate } from 'react-router-dom';
import './CustomerIdentify.scss';
import './FormComponent.scss';

/* Asset */
import roomResearch from 'assets/image/roomResearch.svg';
import owner from 'assets/image/owner.svg';
import managementCompany from 'assets/image/managementCompany.svg';
import intermediary from 'assets/image/intermediary.svg';
import tenant from 'assets/image/tenant.svg';

interface CustomerIdentifyProps {
  tenpoName: string;
  tenpoCode: string;
}

const CustomerIdentify: React.FC<CustomerIdentifyProps> = ({ tenpoCode, tenpoName }) => {
  const navigate = useNavigate();

  const handleReservationClick = () => {
    if (!tenpoCode) {
      console.error('tenpoCode is undefined or empty!');
      return;
    }
    navigate(`/form/${tenpoCode}`);
  };

  const handleOtherClick = () => {
    navigate('/404');
  };

  const buttons = [
    { category: 'tenant', label: '入居者様', icon: tenant, onClick: handleOtherClick },
    { category: 'owner', label: 'オーナー様', icon: owner, onClick: handleOtherClick },
    { category: 'agent', label: '仲介業者様', icon: intermediary, onClick: handleOtherClick },
    {
      category: 'manager',
      label: '管理業者様',
      icon: managementCompany,
      onClick: handleOtherClick,
    },
    { category: 'others', label: 'その他', icon: null, onClick: handleOtherClick },
  ];

  return (
    <div className="customer-identify">
      {/* お部屋探しのお客様 */}
      <section className="customer-identify__section customer-identify__section--large">
        <h2 className="customer-identify__title">お部屋探しのお客様</h2>
        <p className="customer-identify__description">
          当店は予約優先となります。下記よりご予約をお願いします。
        </p>
        <button
          className="customer-identify__circle-button customer-identify__circle-button--large"
          onClick={handleReservationClick}
        >
          <img src={roomResearch} alt="お部屋探し" className="customer-identify__icon" />
          お部屋探しのお客様
        </button>
      </section>

      {/* お部屋探し以外のお客様 */}
      <section className="customer-identify__section">
        <h2 className="customer-identify__title">お部屋探し“以外”のお客様</h2>
        <p className="customer-identify__description">
          スタッフより折り返し連絡させていただきます。下記より受付をお願いします。
        </p>

        {/* ボタン表示 */}
        <div className="customer-identify__row">
          {/* 1行目: ボタン1, ボタン2 */}
          <div className="customer-identify__row--grid customer-identify__row--first">
            {buttons.slice(0, 2).map((button) => (
              <button
                key={button.category}
                className="customer-identify__circle-button customer-identify__circle-button--small"
                onClick={button.onClick}
              >
                {button.icon && (
                  <img
                    src={button.icon}
                    alt={button.label}
                    className="customer-identify__icon customer-identify__icon--small"
                  />
                )}
                {button.label}
              </button>
            ))}
          </div>

          {/* 2行目: ボタン3, ボタン4, ボタン5 */}
          <div className="customer-identify__row--grid customer-identify__row--second">
            {buttons.slice(2).map((button) => (
              <button
                key={button.category}
                className="customer-identify__circle-button customer-identify__circle-button--small"
                onClick={button.onClick}
              >
                {button.icon && (
                  <img
                    src={button.icon}
                    alt={button.label}
                    className="customer-identify__icon customer-identify__icon--small"
                  />
                )}
                {button.label}
              </button>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default CustomerIdentify;
